import { Stack, Typography } from "@mui/material";
import { entityOptionFieldTypeCaptionMap } from "@entrilia/shared/utilities/enumCaptions";
import type { OptionsEntityFieldConfiguration } from "../../../../../api/types/objectTypes";

interface Props {
  fieldConfiguration: OptionsEntityFieldConfiguration;
}

const SelectFieldConfigViewer = ({ fieldConfiguration }: Props) => {
  return (
    <Stack spacing={1} sx={{ pt: 2 }}>
      <Typography variant="subtitle2">Options</Typography>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography color="textSecondary">Dictionary</Typography>
        <Typography>{entityOptionFieldTypeCaptionMap[fieldConfiguration.fieldType]}</Typography>
      </Stack>
    </Stack>
  );
};

export default SelectFieldConfigViewer;
